import {ValueDefinition} from '@/model/types';

export const enum SourcePlans {
  TFSA = 'DV-71#0',
  LIRA_Purchaser_Contractholder = 'DV-71#1',
  LIRA_Member_Contractholder = 'DV-71#2',
  RRIF_Contributing_Spouse = 'DV-71#3',
  RRIF_Contributing_Contractholder = 'DV-71#4',
  LIF_Purchaser_Contractholder = 'DV-71#5',
  LIF_Member_Contractholder = 'DV-71#6',
  NRSP_Non_Registered = 'DV-71#7',
  RRSP_Contributing_Spouse = 'DV-71#8',
  RRSP_Contributing_Contractholder = 'DV-71#9',
  RLIF_Purchaser_Contractholder = 'DV-71#10',
  RLIF_Member_Contractholder = 'DV-71#11',
  RLSP_Purchaser_Contractholder = 'DV-71#12',
  RLSP_Member_Contractholder = 'DV-71#13',
  FHSA = 'DV-71#14',
}

export const DV_71 = {
  id: 'DV-71',
  description: {
    fr: 'Provenances de fonds possibles (transfert d’un compte déjà détenu chez l’assureur)',
    en: 'Possible sources of funds (transfer from an account already held by the insurer)',
  },
  values: [
    {
      id: '0',
      value: {
        fr: 'CELI',
        en: 'TFSA',
      },
    },
    {
      id: '1',
      value: {
        fr: 'CRI - preneur constituant',
        en: 'LIRA - purchaser contractholder',
      },
    },
    {
      id: '2',
      value: {
        fr: 'CRI - preneur participant',
        en: 'LIRA - member contractholder',
      },
    },
    {
      id: '3',
      value: {
        fr: 'FERR - conjoint cotisant',
        en: 'RRIF - contributing spouse',
      },
    },
    {
      id: '4',
      value: {
        fr: 'FERR - preneur cotisant',
        en: 'RRIF - contributing contractholder',
      },
    },
    {
      id: '5',
      value: {
        fr: 'FRV - preneur constituant',
        en: 'LIF - purchaser contractholder',
      },
    },
    {
      id: '6',
      value: {
        fr: 'FRV - preneur participant',
        en: 'LIF - member contractholder',
      },
    },
    {
      id: '7',
      value: {
        fr: 'RENE - Non enregistré',
        en: 'NRSP - Non registered plan',
      },
    },
    {
      id: '8',
      value: {
        fr: 'REER - conjoint cotisant',
        en: 'RRSP - contributing spouse',
      },
    },
    {
      id: '9',
      value: {
        fr: 'REER - preneur cotisant',
        en: 'RRSP - contributing contractholder',
      },
    },
    {
      id: '10',
      value: {
        fr: 'FRVR - preneur constituant',
        en: 'RLIF - purchaser contractholder',
      },
    },
    {
      id: '11',
      value: {
        fr: 'FRVR - preneur participant',
        en: 'RLIF - member contractholder',
      },
    },
    {
      id: '12',
      value: {
        fr: 'REIR - preneur constituant',
        en: 'RLSP - purchaser contractholder',
      },
    },
    {
      id: '13',
      value: {
        fr: 'REIR - preneur participant',
        en: 'RLSP - member contractholder',
      },
    },
    {
      id: '14',
      value: {
        fr: 'CELIAPP',
        en: 'FHSA',
      },
    },
  ],
} as const satisfies ValueDefinition;
